<template>
  <main class="dashboard reviews">
    <div class="container-fluid container-fluid--max">
      <h1 class="d-none">Mes avis</h1>
      <section class="dash-reviews__prdts card">
        <div class="card-body mx-lg-4">
          <h2 class="dashboard__title heading-secondary">Avis produits</h2>
          <ProductReviews />
        </div>
      </section>
      <section class="dash-reviews__assist card mt-4">
        <div class="card-body mx-lg-4">
          <h2 class="dashboard__title heading-secondary">Avis demandes d'assistance</h2>
          <SupportReviews />
        </div>
      </section>
    </div>
  </main>
</template>

<script>
import ProductReviews from './ProductReviews'
import SupportReviews from './SupportReviews'
import { scrollAnchor } from '@/utils/helpers'

export default {
  name: 'Reviews',
  components: {
    ProductReviews,
    SupportReviews
  },
  mounted () {
    scrollAnchor(this.$router)
  }
}
</script>
